/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Standard libraries
import styled from "@mui/styled-engine-sc";
import EspotGeneral from "components/custom/spot/SpotTemplate";
import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";


/**
 * MiniCart component
 * displays number of cart items icon
 * @param props
 */

export const StyledPromoHeader = styled("header")`
  ${({ theme }) => `

    .spot-promoHeader {
      background-color: #263645;
      color: white;
      font-size: 13px;
      font-family: Inter;
      font-weight: normal;
      height: 30px;
      display: flex;
      padding: 0px 0px;
      align-items: center;
      text-align: center;
      justify-content: center;
      align-self: center;
    }

    @media (min-width: ${theme.breakpoints.values.sm}px) {
      .spot-promoHeader {
        background-color: #263645;
        color: white;
        font-size: 13px;
        font-family: Inter;
        font-weight: normal !important;
        height: 35px;
        display: flex;
        padding: 0px 0px;
        align-items: center;
        text-align: center;
        justify-content: center;
        align-self: center;
      }
    }

    @media (min-width: ${theme.breakpoints.values.md}px) {
      .spot-promoHeader {
        background-color: #263645;
        color: white;
        font-size: 13px;
        font-family: Inter;
        font-weight: normal !important;
        height: 35px;
        display: flex;
        padding: 0px 0px;
        align-items: center;
        text-align: center;
        justify-content: center;
        align-self: center;
      }
    }
    `}
  `;

const PromoHeader = () => {
  
  const theme = useTheme();
  const isMobile = !useMediaQuery(theme.breakpoints.up("sm"));
  const isTablet = !useMediaQuery(theme.breakpoints.up("md"));

  return (
    <>
    {/* En este componente se utiliza un espot para traer el texto de promoción. Este texto
        estará dentro de una pestaña color azul.*/}
    <StyledPromoHeader>
        <EspotGeneral espotName="PromocionHeader" />
    </StyledPromoHeader>
    </>
  );
};


export default PromoHeader;
